import { SharedTradeInterface } from '../../../ng-services/social-trading/trade-sharing.store';
import toastr from 'toastr';
import { ChartMarkLineInterface } from '../../chart/candlestick-chart.component';
import { parseTradeSetupOrders } from '../../../services/shared-trade.util';

export class TradeSharingTableRowDetailsComponent {
    trade!: SharedTradeInterface;

    setupText = '';
    markLines!: ChartMarkLineInterface[];

    $onInit() {
        this.setupText = this.trade.posts?.[0].content;

        const orders = parseTradeSetupOrders(this.trade.setup_file.orders);
        this.markLines = orders.map((order) => ({
            name: order.label,
            yAxis: order.price,
            color: order.isSellOrder ? '#f52121' : '#2ed200',
        }));
    }

    copy() {
        navigator.clipboard.writeText(this.setupText).then(
            () => toastr.success('Setup Text copied to clipboard'),
            () => toastr.error('Clipboard error')
        );
    }
}

angular.module('tradersyard').component('tyTradeSharingTableRowDetailsComponent', {
    // language=HTML
    template: `
        <div class="row">
            <div class="col-sm-12 col-md-4">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="panel panel-default description_panel">
                            <div class="panel-heading">
                                <h3 class="panel-title">Setup Text</h3>
                            </div>
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="wrapper">
                                            <pre><code>{{$ctrl.setupText}}</code></pre>
                                        </div>
                                    </div>
                                    <div class="col-sm-1">
                                        <button ng-click="$ctrl.copy()" class="btn btn-default">Copy to clipboard</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-8">
                <ty-candlestick-chart symbol="$ctrl.trade.symbol" mark-lines="$ctrl.markLines"/>
            </div>
        </div>
    `,
    controller: TradeSharingTableRowDetailsComponent,
    bindings: {
        trade: '<',
    },
});
